import { TrendingUp, Shield, AlertTriangle, ArrowRight, Zap } from 'lucide-react';

const RISK_CARDS = [
  {
    title: 'Overall Risk Score',
    score: 24,
    max: 100,
    color: 'text-amber-400',
    bg: 'bg-amber-400',
    trend: '-3% from last week',
    trendGood: true,
  },
  {
    title: 'Critical Vulnerabilities',
    score: 3,
    max: null,
    color: 'text-red-400',
    bg: 'bg-red-400',
    trend: '+1 new this week',
    trendGood: false,
  },
  {
    title: 'Patch Compliance',
    score: 94,
    max: 100,
    color: 'text-emerald-400',
    bg: 'bg-emerald-400',
    trend: '+2% improvement',
    trendGood: true,
  },
];

const RECOMMENDATIONS = [
  { title: 'Patch CVE-2026-1234 on srv-web-01', severity: 'Critical', action: 'Apply security update to nginx 1.24.0', impact: 'High' },
  { title: 'Review firewall rules on fw-corp-01', severity: 'Medium', action: 'Audit outbound rule added in last 24h', impact: 'Medium' },
  { title: 'Rotate exposed API key sk_sentinel_****', severity: 'High', action: 'Revoke and reissue compromised credential', impact: 'High' },
  { title: 'Enable MFA for finance workstations', severity: 'Medium', action: 'Deploy MFA policy to ws-finance-* group', impact: 'Medium' },
  { title: 'Update threat intel feeds', severity: 'Low', action: 'Re-enable AlienVault OTX connector', impact: 'Low' },
];

const RiskAssessment = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">Risk Assessment</h1>
      <p className="text-sm text-gray-500 mt-1">
        AI-generated summaries and suggested response playbooks · PRD: AI-01, AI-03 (Section 7.9)
      </p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {RISK_CARDS.map((card, i) => (
        <div key={i} className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
          <div className="flex items-center gap-2 mb-4">
            {card.title.includes('Vulnerabilities') ? (
              <AlertTriangle className="w-4 h-4 text-red-400" />
            ) : card.title.includes('Patch') ? (
              <Shield className="w-4 h-4 text-emerald-400" />
            ) : (
              <TrendingUp className="w-4 h-4 text-cyan-400" />
            )}
            <h3 className="text-sm font-medium text-gray-400">{card.title}</h3>
          </div>
          <div className="flex items-end gap-2 mb-3">
            <span className={`text-4xl font-bold font-mono ${card.color}`}>{card.score}</span>
            {card.max && <span className="text-gray-600 text-lg pb-1">/ {card.max}</span>}
          </div>
          <p className={`text-xs ${card.trendGood ? 'text-emerald-400' : 'text-red-400'}`}>{card.trend}</p>
        </div>
      ))}
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Zap className="w-5 h-5 text-cyan-400" />
          <h2 className="text-lg font-semibold text-white">AI Recommendations</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
          Coming Soon
        </span>
      </div>

      <div className="space-y-2">
        {RECOMMENDATIONS.map((rec, i) => (
          <div
            key={i}
            className="flex items-center justify-between px-4 py-3 bg-gray-950/60 rounded-lg border border-gray-800/60 hover:border-gray-700 transition-colors"
          >
            <div className="flex items-start gap-3">
              <ArrowRight className="w-4 h-4 text-cyan-400 mt-0.5 shrink-0" />
              <div>
                <p className="text-sm font-medium text-white">{rec.title}</p>
                <p className="text-xs text-gray-500 mt-0.5">{rec.action}</p>
              </div>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <span className={`px-2 py-0.5 rounded text-xs font-mono font-medium border ${
                rec.severity === 'Critical' ? 'bg-red-500/20 text-red-400 border-red-500/30' :
                rec.severity === 'High' ? 'bg-red-500/20 text-red-400 border-red-500/30' :
                rec.severity === 'Medium' ? 'bg-amber-500/20 text-amber-400 border-amber-500/30' :
                'bg-emerald-500/20 text-emerald-400 border-emerald-500/30'
              }`}>
                {rec.severity}
              </span>
              <span className="text-xs text-gray-600 font-mono">{rec.impact}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default RiskAssessment;
